module.exports = __webpack_public_path__ + "img/mq.d7b33aeb.svg";